module.exports = __webpack_public_path__ + "img/a125d8a4-4a3d-4aa2-a34d-b67cf6755029.e0ff81a4.webp";